module.exports = __webpack_public_path__ + "img/Screen_Recording_14-03-2022_at_22.54.c94e42b8.gif";